export default {
    welcome: 'Welcome',
    welcomeToYourDashboard: 'Welcome To Your Dashboard'
}
